import { useEffect, useState } from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

function AvatarPlaceholder({ sex }) {
  const shoulderPath = sex === "MALE"
    ? "M9 58c0-10 10-17 23-17s23 7 23 17v6H9v-6Z"
    : sex === "FEMALE"
      ? "M15 60c0-11 7.5-19 17-19s17 8 17 19v4H15v-4Z"
      : "M12 57c0-10.5 9-18 20-18s20 7.5 20 18v7H12v-7Z";

  return (
    <svg
      className="lz-v2-avatar__placeholder"
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="32" cy="32" r="32" className="lz-v2-avatar__placeholder-bg" />
      <circle cx="32" cy="25" r="10" className="lz-v2-avatar__placeholder-mark" />
      <path d={shoulderPath} className="lz-v2-avatar__placeholder-mark" />
    </svg>
  );
}

export default function Avatar({
  src = null,
  sex = null,
  size = 48,
  alt = "",
  loading = "lazy",
  decoding = "async",
  className = "",
  onLoad,
  onError,
  ...props
}) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const dimension = Number.isFinite(size) ? size : 48;
  const placeholder = sex === "MALE" ? "male" : sex === "FEMALE" ? "female" : "neutral";

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
  }, [src]);

  return (
    <span
      {...props}
      className={joinClassNames("lz-v2-avatar", className)}
      style={{ width: dimension, height: dimension, ...props.style }}
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : "true"}
      data-placeholder={placeholder}
      data-state={!src ? "placeholder" : failed ? "error" : loaded ? "loaded" : "loading"}
    >
      <AvatarPlaceholder sex={sex} />
      {src && !failed ? (
        <img
          className="lz-v2-avatar__image"
          data-testid="lz-v2-avatar-image"
          src={src}
          alt=""
          width={dimension}
          height={dimension}
          loading={loading}
          decoding={decoding}
          data-loaded={loaded ? "true" : "false"}
          onLoad={(event) => {
            setLoaded(true);
            onLoad?.(event);
          }}
          onError={(event) => {
            setFailed(true);
            onError?.(event);
          }}
        />
      ) : null}
    </span>
  );
}
